import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const File: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden={!title}
      focusable='false'
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      {...props}
    >
      {title && <title>{title}</title>}
      <path
        d='M16 6.25C16.4142 6.25 16.75 6.58579 16.75 7C16.75 7.41421 16.4142 7.75 16 7.75H8C7.58579 7.75 7.25 7.41421 7.25 7C7.25 6.58579 7.58579 6.25 8 6.25H16Z'
        fill={fill}
      />
      <path
        d='M12 10.25C12.4142 10.25 12.75 10.5858 12.75 11C12.75 11.4142 12.4142 11.75 12 11.75H8C7.58579 11.75 7.25 11.4142 7.25 11C7.25 10.5858 7.58579 10.25 8 10.25H12Z'
        fill={fill}
      />
      <path
        d='M19.25 13.3428V10C19.25 8.09324 19.2485 6.73859 19.1104 5.71094C18.992 4.83058 18.7832 4.27639 18.4492 3.86816L18.2979 3.70215C17.8747 3.27896 17.2952 3.02491 16.2891 2.88965C15.2614 2.7515 13.9067 2.75 12 2.75C10.0932 2.75 8.73859 2.7515 7.71094 2.88965C6.83057 3.00801 6.27639 3.21684 5.86816 3.55078L5.70215 3.70215C5.27894 4.12536 5.02491 4.70485 4.88965 5.71094C4.7515 6.73859 4.75 8.09324 4.75 10V14.5439C4.75 16.1845 4.75098 17.3501 4.85547 18.2451C4.95808 19.1239 5.15161 19.6455 5.46973 20.04L5.58203 20.1719C5.69815 20.3011 5.82452 20.4211 5.95996 20.5303L6.11426 20.6436C6.4904 20.8952 6.98579 21.0547 7.75488 21.1445C8.64989 21.249 9.81551 21.25 11.4561 21.25C11.8419 21.25 12.0832 21.247 12.25 21.2363V21C12.25 19.6071 12.2481 18.4869 12.3662 17.6084C12.4872 16.7083 12.7467 15.9506 13.3486 15.3486C13.9506 14.7467 14.7083 14.4872 15.6084 14.3662C16.4869 14.2481 17.6071 14.25 19 14.25H19.2334C19.2468 14.0579 19.25 13.7807 19.25 13.3428ZM18.1875 15.751C17.1733 15.7546 16.4124 15.7724 15.8086 15.8535C15.0748 15.9522 14.686 16.1324 14.4092 16.4092C14.1324 16.686 13.9522 17.0748 13.8535 17.8086C13.7724 18.4124 13.7546 19.1733 13.751 20.1875L18.1875 15.751ZM20.75 13.3428C20.75 14.0045 20.7598 14.5369 20.6133 15.0195L20.541 15.2236C20.3184 15.7611 19.8933 16.1673 19.3584 16.7021L14.6221 21.4385C14.1603 21.9003 13.8101 22.2643 13.3584 22.4805L13.3574 22.4814C13.3135 22.5024 13.2688 22.5223 13.2236 22.541L13.0869 22.5938C12.6146 22.7604 12.1093 22.75 11.4561 22.75C9.85178 22.75 8.58325 22.7508 7.58106 22.6338C6.6264 22.5223 5.82867 22.2965 5.15234 21.8008L5.01856 21.6982C4.82085 21.5388 4.63637 21.3635 4.4668 21.1748L4.30176 20.9814C3.73395 20.2771 3.4851 19.4372 3.36621 18.4189C3.24922 17.4168 3.25 16.1482 3.25 14.5439V10C3.25 8.13558 3.24859 6.66159 3.40332 5.51074C3.56096 4.33844 3.89329 3.38991 4.6416 2.6416L4.78418 2.50586C5.50929 1.85227 6.41176 1.5511 7.51074 1.40332C8.66159 1.24859 10.1356 1.25 12 1.25C13.8644 1.25 15.3384 1.24859 16.4893 1.40332C17.6616 1.56096 18.6101 1.89328 19.3584 2.6416L19.4941 2.78418C20.1477 3.50929 20.4489 4.41176 20.5967 5.51074C20.7514 6.66159 20.75 8.13558 20.75 10V13.3428Z'
        fill={fill}
      />
    </svg>
  )
}

export default File
